import Skeleton from '@/shared/components/Skeleton';
import { useIsMobile } from '@/shared/hooks/useMediaQuery';
import { S } from '@/shared/constants/styles';

export default function TransactionsSkeleton({ theme: t }) {
  const mobile = useIsMobile();

  return (
    <div>
      {/* Header row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, gap: 10 }}>
        <Skeleton width={180} height={14} theme={t} />
        <div style={{ display: 'flex', gap: 8 }}>
          <Skeleton width={120} height={36} borderRadius={8} theme={t} />
          <Skeleton width={140} height={36} borderRadius={8} theme={t} />
        </div>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <Skeleton width={200} height={36} borderRadius={8} theme={t} />
        <Skeleton width={140} height={36} borderRadius={8} theme={t} />
        <Skeleton width={140} height={36} borderRadius={8} theme={t} />
      </div>

      {/* Table/cards */}
      <div style={{ ...S.card, padding: 0, overflow: 'hidden', background: t.cardBg, borderColor: t.cardBorder }}>
        {mobile ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {Array.from({ length: 8 }, (_, i) => (
              <div key={i} style={{ padding: 14, display: 'flex', gap: 12, alignItems: 'center', borderBottom: '1px solid ' + t.cardBorder }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <Skeleton width="60%" height={13} theme={t} />
                  <Skeleton width="40%" height={10} theme={t} />
                </div>
                <Skeleton width={60} height={14} theme={t} />
              </div>
            ))}
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Date', 'Description', 'Category', 'Who', 'Amount', ''].map((h, i) => (
                  <th key={i} style={{ ...S.th, color: t.textMuted, borderBottom: '1px solid ' + t.cardBorder }}>
                    <Skeleton width={h ? h.length * 8 : 40} height={10} theme={t} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 10 }, (_, i) => (
                <tr key={i} style={{ borderBottom: '1px solid ' + t.cardBorder }}>
                  <td style={{ padding: '12px 10px' }}><Skeleton width={70} height={12} theme={t} /></td>
                  <td style={{ padding: '12px 10px' }}><Skeleton width="70%" height={12} theme={t} /></td>
                  <td style={{ padding: '12px 10px' }}><Skeleton width={80} height={12} theme={t} /></td>
                  <td style={{ padding: '12px 10px' }}><Skeleton width={60} height={12} theme={t} /></td>
                  <td style={{ padding: '12px 10px' }}><Skeleton width={50} height={12} theme={t} /></td>
                  <td style={{ padding: '12px 10px' }}><Skeleton width={40} height={12} theme={t} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
